import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'app-list-loading',
	templateUrl: './list-loading.component.html',
	styleUrls: ['./list-loading.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ListLoadingComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
